import { ApplicationPanelistReviewForm } from '../../../../../../forms/application/panelist-review'

export const ApplicationPanelistReview = () => {
  return <ApplicationPanelistReviewForm />
}
